import styled from '@emotion/styled';
import { Typography } from '@utex/ui-kit';
import { LinkProps } from '@utex/ui-kit/dist/common/Typography/LinkText';

export const HintLink = styled(Typography.LinkText)<LinkProps>`
  text-decoration: underline;
`;
